export default "https://cdn-static.gokick.com/assets/e21cd8011b9b3a74c4cd288f1b94a870d12ac47c/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";